document.addEventListener('DOMContentLoaded', function() {
  var header = document.querySelector('.header');
  var parent = document.querySelector('#shopify-section-header');

  if (!header || !parent) return;

  // Function to check sticky state
  function updateStickyBackground() {
    if (header.classList.contains('is-sticky')) {
      parent.classList.add('sticky-bg');
    } else {
      parent.classList.remove('sticky-bg');
    }
  }

  // Initial check in case header is already sticky
  updateStickyBackground();

  // Watch scroll events
  window.addEventListener('scroll', updateStickyBackground);
});
